export const PRIME_LOGIN_REDIRECT_URL = '/primedashboard';
export const CONTACT_LOGIN_REDIRECT_URL = '/dashboard';

//Alphabets Starts With
const alphaASCII = Array.from(Array(26)).map((e, i) => i + 65);
const numArray = Array.from(Array(10).keys()).map((num) => num.toString());
const alphaArray = alphaASCII.map((alpha) => String.fromCharCode(alpha));
const alphaNumericArray = [...numArray, ...alphaArray];
const createAlphabetStartsWith = (value: string) => ({
    key: value,
    value: value,
    text: value,
});

export const alphaNumericStartsWith = alphaNumericArray.map((alpha) =>
    createAlphabetStartsWith(alpha)
);
export const alphabetStartsWith = alphaASCII.map((alpha) =>
    createAlphabetStartsWith(String.fromCharCode(alpha))
);

//Status
export const status = [
    {
        key: 'Active',
        value: '1',
        text: 'Active',
    },
    {
        key: 'Inactive',
        value: '0',
        text: 'Inactive',
    },
];

//subContractorType
export const subContractorType = [
    {
        key: 'All',
        value: 'All',
        text: 'All',
    },
    {
        key: 'Tier II',
        value: '0',
        text: 'Tier II',
    },
    {
        key: 'Tier III',
        value: '1',
        text: 'Tier III',
    },
];

// const createSubContractorType = (value: string, index: number) => ({
//     label: value,
//     text: value,
//     value: index,
// });

// export const subContractor_Type = subContractorType.map((value, index) =>
// createSubContractorType(value, index)
// );

//Month
export const MONTH_NAME_ARRAY = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const createMonth = (value: string, index: number) => ({
    label: value,
    text: value,
    value: index + 1,
});

export const month = MONTH_NAME_ARRAY.map((month, index) =>
    createMonth(month, index)
);

//Literals
const createLiteral = (label: string, value: string) => ({
    label: label,
    value: value,
});

export const literals = [
    createLiteral('ALL', ' '),
    createLiteral('0-9', '0-9'),
    createLiteral('A-C', 'A-C'),
    createLiteral('D-F', 'D-F'),
    createLiteral('G-I', 'G-I'),
    createLiteral('J-L', 'J-L'),
    createLiteral('M-O', 'M-O'),
    createLiteral('P-R', 'P-R'),
    createLiteral('S-U', 'S-U'),
    createLiteral('V-X', 'V-X'),
    createLiteral('Y-Z', 'Y-Z'),
];

//States
const unsortedState = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];
export const states = unsortedState.sort();

export const border = {
    bottom: {
        style: 'thin',
        color: 'FF000000',
    },
    top: {
        style: 'thin',
        color: 'FF000000',
    },
    right: {
        style: 'thin',
        color: 'FF000000',
    },
    left: {
        style: 'thin',
        color: 'FF000000',
    },
};
export const centerAlignment = {
    vertical: 'center',
    horizontal: 'center',
    wrapText: true,
    indent: 1,
};
export const leftAlignment = {
    vertical: 'center',
    horizontal: 'left',
    wrapText: true,
    indent: 1,
};
export const rightAlignment = {
    vertical: 'center',
    horizontal: 'right',
    wrapText: true,
    indent: 1,
};

export const reportHeaderBackground = {
    fgColor: { rgb: '8DB4E2' }, //add background color
};
export const reportHeaderFont = {
    name: 'Calibri', //font
    sz: 12, //font size
    bold: true, //bold
};
export const reportCellFont = {
    name: 'Calibri', //font
    sz: 12, //font size
    bold: false, //bold
};

const createState = (value: string) => ({
    key: value,
    value: value,
    text: value,
});

export const stateOption = states.map((state) => createState(state));

// Blank Select Option
export const blankSelectOption = {
    key: '',
    value: null,
    text: '-Select-',
};

export const allWithBankValueSelectOption = {
    key: '',
    value: '',
    text: 'ALL',
};

export const yearObject = [
    {
        key: new Date().getFullYear(),
        text: new Date().getFullYear(),
        value: new Date().getFullYear(),
    },
    {
        key: new Date().getFullYear() - 1,
        text: new Date().getFullYear() - 1,
        value: new Date().getFullYear() - 1,
    },
];

const templateBody1 =
    'Valued Prime Suppliers,\n\nYour subcontracting input due date is 5:00 pm PST on <day of month>, <current month> 7th. Please take a moment when you login to make sure your contact information is current and that you have listed at least one other person at your company as a contact, if possible.\n\nIf your company has no current contracts with San Diego Gas & Electric (SDG&E) or Southern California Gas Company (SoCalGas) and your subcontracting was current at the time contract expired, please disregard this email.\n\nThank you for your commitment to meeting your subcontracting goals. If you have any questions or need help using our subcontracting portal, please contact Sempra_Subcontracting@sempra.com\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';
const templateBody2 =
    'Valued Prime Suppliers,\n\nDue to the <holiday or system outage>, the subcontracting input due date has been extended to 5:00 pm PST on <day of month>, <Month> <new date> Please take a moment when you login to make sure your contact information is current and that you have listed at least one other person at your company as a contact, if possible.\n\nIf your company has no current contracts with San Diego Gas & Electric (SDG&E) or Southern California Gas Company (SoCalGas) and your subcontracting was current at the time contract expired, please disregard this email.\n\nThank you for your commitment to meeting your subcontracting goals. If you have any questions or need help using our subcontracting portal, please contact Sempra_Subcontracting@sempra.com\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';
const templateBody3 =
    'Valued Prime Suppliers,\n\nSDG&E and SoCalGas will be performing their annual subcontracting audits again this year. The purpose of the audit is to validate that subcontracting spend is being input correctly. If your company is among those selected for auditing, the audit will compare your reported spend to your subcontractors reported remittances from you. Please ensure that any payments (cash basis; not accruals) you made to your subcontractors from January 1, <Current Reporting Year> to August 31, < Current Reporting Year>, as determined by the subcontractor payment date, are reflected accurately in our subcontracting portal. This will help reduce the discrepancies our outside auditing firm needs to research and will save you and your subcontractors time and effort in the reconciliation process.\n\nPlease ensure that your company is compliant with the following requirements:\n\n• Cooperate fully and in a timely fashion with any audit requests and ask your subcontractors to do the same.\n\n• Report your spend by month based on the month and year of payment to your subcontractors. You should not be reporting estimates or using invoice or performance dates to record your spend. This is a CPUC requirement and there are no exceptions.\n\n• Please note that if your January to August spend changes significantly by our January reporting deadline, you will be required to provide a written explanation to our auditor. If not, the updated spend may not be included in our final <Current Reporting Year> subcontracting results and will not count towards your goals.\n\nWe appreciate your cooperation in this audit process. Thank you for your reporting and please contact us at Sempra_Subcontracting@sempra.com if you have any questions.\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';
const templateBody4 =
    'Valued Prime Suppliers,\n\nSDG&E and SoCalGas are contacting you to remind you of California Public Utilities Commission (CPUC) supplier diversity reporting requirements that may affect your subcontracting results. Per the CPUC, the utilities cannot report any spend as diverse spend if the payment date is past the verification expiration date.\n\nExample:\n\n• ABC Company has a verification expiration date of 11/08/2021.\n• The payment from you to your subcontractor was issued on 11/15/2021. This payment cannot be counted towards your subcontracting goals even though the supplier held valid verification at the time they performed the services for you.\n• Please note that expiration dates are inclusive so if, in the example above, you paid the subcontractor on 11/08/2021, the spend can still be counted towards your subcontracting goals and we can include it in our annual report to the CPUC.\n• As in previous years, and per the CPUC, the verification renewal must be completed by the end of the year and the new expiration date must be reflected in the Supplier Clearinghouse no later than the last day of the reporting year for your spend to count towards your goals. There are no exceptions.\n\nSince we do not have access to the payment date information for your subcontractor(s) at a month/day level, we are requesting you do the following:\n\n• If you have subcontractors with spend who have expiration dates earlier than your payment dates, or to whom you expect to make payments after the expiration date, please contact them immediately and ask they submit a reverification application through the Supplier Clearinghouse at www.thesupplierclearinghouse.com\n• If there is a possibility that you will be adding or reporting spend against new subcontractors or older subcontractors for the first time this year, please check their verification expiration dates and reach out to them to request they reverify as well, if they have an expiration date in the reporting year.\n• If your subcontractor cannot or will not be reverified by year-end, please back out any payments made prior to their expiration date. This is required to be completed by COB on January 7th.\n\nIf your company has no current contracts with San Diego Gas & Electric (SDG&E) or Southern California Gas Company (SoCalGas) and your subcontracting was current at the time contract expired, please disregard this email.\n\nThank you for ensuring our data is CPUC-compliant. Please address any questions or concerns to Sempra_Subcontracting@sempra.com\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';
const templateBody5 =
    'Valued Prime Suppliers,\n\nThank you to all of you who entered your subcontracting for <current reporting year>. You made a difference not only in our results but in the communities we serve.\n\nWe strongly suggest that you download the subcontracting reports available to you monthly.  This is especially important  as we begin a new reporting year.  The reports will only be available for downloading until the end of January and will not be available from any source after January.\n\nIf your company has no current contracts with San Diego Gas & Electric (SDG&E) or Southern California Gas Company (SoCalGas) and your subcontracting was current at the time contract expired, please disregard this email.\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';
const templateBody6 =
    'Valued Prime Suppliers,\n\nOn behalf of San Diego Gas & Electric and Southern California Gas Company, we want to thank you for your continued support in assisting us with our diverse spend subcontracting goals.  However, subcontracting reporting overall is still below the goal.  We are providing the following reminders of your responsibilities as a Prime Contractor.\n\nAs a Prime Contractor,\n• We encourage you to continue working with diverse subcontractors.\n• You are responsible for recording your subcontracting spend with your diverse suppliers in our portal at https://dbe-public.sempra.com/\n• Please record your subcontracting spend by close of business on the 7th of each month\n• You are responsible for verifying your diverse subcontractor’s certification status and ensuring it remains current\n• If you are not current in your reporting, please be advised that you are able to update your spend back to the January 1st of the reporting year.\n\nIf your company has no current contracts with San Diego Gas & Electric (SDG&E) or Southern California Gas Company (SoCalGas) and your subcontracting was current at the time contract expired, please disregard this email.\n\nFor assistance with entering your spend, detailed Instructions and videos are available by selecting “Help” from the profile icon in the upper right corner of the subcontracting portal.  If you need any assistance in finding a diverse subcontractor or have any questions about your subcontracting reporting, please reach out to us at Sempra_Subcontracting@sempra.com. Thank you.\n\nSupplier Diversity Team\nSan Diego Gas & Electric Company (SDG&E)\nSouthern California Gas Company (SoCalGas)';

const createEmailTemplateOption = (
    key: any,
    templateName: string,
    subject: string,
    body: string
) => ({
    key: key,
    templateName: templateName,
    subject: subject,
    body: body,
});

export const emailTemplateOptions = [
    createEmailTemplateOption(
        '1',
        'Default Monthly Subcontracting Reminder',
        'SDG&E and SoCalGas Subcontracting Reminder',
        templateBody1
    ),
    createEmailTemplateOption(
        '2',
        'Subcontracting Due Date Extension',
        'SDG&E and SoCalGas Subcontracting Due Date Extension',
        templateBody2
    ),
    createEmailTemplateOption(
        '3',
        'Subcontracting Audit Notification',
        'Subcontracting Audit Reminder',
        templateBody3
    ),
    createEmailTemplateOption(
        '4',
        'YE Notification Regarding Verification Status',
        'Expired or Expiring Subcontractor Responsibilities Reminder',
        templateBody4
    ),
    createEmailTemplateOption(
        '5',
        'YE Report Downloads Reminder',
        'YE Report Download Reminder',
        templateBody5
    ),
    createEmailTemplateOption(
        '6',
        'Prime Reporting Responsibilities Reminder',
        'Prime Reporting Responsibilities Reminder',
        templateBody6
    ),
];

//Status
export const viewAllSubStatus = [
    {
        key: 'All',
        value: '',
        text: 'All',
    },
    {
        key: 'Active',
        value: 'false',
        text: 'Active',
    },
    {
        key: 'Inactive',
        value: true,
        text: 'Inactive',
    },
];
export const DEFAULT_PHONE_NO = '000-000-0000';
